module.exports = __webpack_public_path__ + "media/images/svg/tripadvisor-cb6309c68505b166b8400d8ec38ac66d.svg";